// src/language/billLanguage.js
const billLanguage = {
  en: {
    pageTitle: 'Manage Bills',
    searchCustomerPlaceholder: 'Search Customer...',
    fullPayment: 'Full Payment',
    amountToPay: 'Amount to Pay',
    pending: 'Pending',
    currentBill: 'Current Bill',
    totalDue: 'Total Due',
    save: 'Save',
    filter: 'Filter',
    billPaid: 'Bill Paid',
    billUnpaid: 'Bill Unpaid',
    unpaidWithPending: 'Unpaid with Pending',
    clearFilter: 'Clear',

    // Bill History Popup
    settleBill: 'Settle Bill',
    saveBill: 'Save Bill',
    amount: 'Amount',
    previousMonths: 'Previous Months',
    max: 'Max',
    enterAmount: 'Enter amount',
    currentMonth: 'Current Month',
    previousMonth: 'Previous Month',
    billHistory: 'Bill History',
    billingPeriod: 'Billing Period',
    previousPending: 'Previous Pending',
    amountPaid: 'Amount Paid',
    newPending: 'New Pending',
    paidDate: 'Paid Date',
    noHistory: 'No billing history found',
    close: 'Close',
    entries: 'entries',
  },
  mr: {
    pageTitle: 'बिल मॅनेजमेंट',
    searchCustomerPlaceholder: 'ग्राहक शोधा...',
    fullPayment: 'पूर्ण पेमेंट',
    amountToPay: 'देय रक्कम',
    pending: 'बाकी',
    currentBill: 'चालू बिल',
    totalDue: 'एकूण देय',
    save: 'सेव्ह करा',
    filter: 'फिल्टर',
    billPaid: 'बिल भरले',
    billUnpaid: 'बिल न भरलेले',
    unpaidWithPending: 'बाकी सह न भरलेले',
    clearFilter: 'साफ करा',

    // Bill History Popup
    settleBill: 'बिल सेटल करा',
    saveBill: 'बिल सेव्ह करा',
    amount: 'रक्कम',
    previousMonths: 'मागील महिने',
    max: 'जास्तीत जास्त',
    enterAmount: 'रक्कम टाका',
    currentMonth: 'चालू महिना',
    previousMonth: 'मागील महिना',
    billHistory: 'बिल इतिहास',
    billingPeriod: 'बिलिंग कालावधी',
    previousPending: 'मागील बाकी',
    amountPaid: 'भरलेली रक्कम',
    newPending: 'नवीन बाकी',
    paidDate: 'भरण्याची तारीख',
    noHistory: 'बिल इतिहास आढळला नाही',
    close: 'बंद करा',
    entries: 'नोंदी',
  },
};

export default billLanguage;
